import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"error\"><g stroke-width=\"0\" fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#DB0000\" cx=\"8\" cy=\"8\" r=\"8\" /><path d=\"M11.048 4.952l-6.096 6.096M4.952 4.952l6.096 6.096\" stroke=\"#FFF\" stroke-width=\"2\" stroke-linecap=\"square\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id